/* ============================================================
   HILEVA — interacciones
   Vanilla, sin librerias. Cada init es idempotente (guard por
   elemento) para sobrevivir a los re-render del editor de Shopify.
   ============================================================ */
(function () {
  'use strict';

  if (window.__hlInit) return;
  window.__hlInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function claim(el, key) {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveals compartidos ---------- */
  var revealObserver = null;
  function initReveals() {
    var nodes = document.querySelectorAll('.hl-reveal:not([data-hlReveal])');
    if (!nodes.length) return;

    if (reduced) {
      nodes.forEach(function (n) { n.dataset.hlReveal = '1'; n.classList.add('hl-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hl-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    }
    nodes.forEach(function (n) { n.dataset.hlReveal = '1'; revealObserver.observe(n); });
  }

  /* ---------- Antes / despues con deslizador (arquetipo 36) ---------- */
  function initCompare() {
    document.querySelectorAll('.hl-compare__frame').forEach(function (frame) {
      if (!claim(frame, 'hlCompare')) return;
      var handle = frame.querySelector('.hl-compare__handle');
      var after = frame.querySelector('.hl-compare__after');
      if (!handle || !after) return;

      function setClip(pct) {
        pct = Math.min(Math.max(pct, 0), 100);
        frame.style.setProperty('--hl-clip', pct + '%');
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }

      function fromEvent(clientX) {
        var r = frame.getBoundingClientRect();
        setClip(((clientX - r.left) / r.width) * 100);
      }

      var dragging = false;
      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        fromEvent(e.clientX);
      });
      handle.addEventListener('pointerup', function () { dragging = false; });
      handle.addEventListener('pointercancel', function () { dragging = false; });

      handle.setAttribute('role', 'slider');
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(frame.style.getPropertyValue('--hl-clip')) || 50;
        if (e.key === 'ArrowLeft') { setClip(current - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setClip(current + 5); e.preventDefault(); }
      });

      frame.addEventListener('click', function (e) {
        if (e.target.closest('.hl-compare__handle')) return;
        fromEvent(e.clientX);
      });
    });
  }

  /* ---------- Pasos con pestañas verticales (arquetipo 50) ---------- */
  function initSteps() {
    document.querySelectorAll('.hl-steps').forEach(function (steps) {
      if (!claim(steps, 'hlSteps')) return;
      var tabs = Array.prototype.slice.call(steps.querySelectorAll('.hl-steps__tab'));
      var imgs = Array.prototype.slice.call(steps.querySelectorAll('.hl-steps__media img'));
      if (!tabs.length) return;
      var autoplayMs = parseInt(steps.dataset.autoplay || '0', 10);
      var timer = null;

      function activate(index) {
        tabs.forEach(function (t, i) { t.dataset.active = i === index ? 'true' : 'false'; });
        imgs.forEach(function (im, i) { im.dataset.active = i === index ? 'true' : 'false'; });
      }

      function scheduleAutoplay() {
        if (!autoplayMs || reduced) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var current = tabs.findIndex(function (t) { return t.dataset.active === 'true'; });
          activate((current + 1) % tabs.length);
          scheduleAutoplay();
        }, autoplayMs);
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i);
          scheduleAutoplay();
        });
      });

      activate(0);
      scheduleAutoplay();
    });
  }

  /* ---------- Cifras de confianza (arquetipo 44) ---------- */
  function initStats() {
    var nodes = document.querySelectorAll('.hl-stats__num[data-target]');
    if (!nodes.length) return;

    function run(el) {
      var target = parseFloat(el.dataset.target);
      var suffix = el.dataset.suffix || '';
      if (reduced || isNaN(target)) { el.textContent = target + suffix; return; }
      var start = null;
      var dur = 1400;
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.textContent = target + suffix;
      }
      function step(ts) {
        if (done) return;
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else finish();
      }
      requestAnimationFrame(step);
      // Salvaguarda: si el tab esta en segundo plano, rAF se pausa y el
      // contador se queda en 0 — nunca dejar el numero real sin mostrar.
      setTimeout(finish, dur + 800);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    nodes.forEach(function (n) {
      if (!claim(n, 'hlStat')) return;
      obs.observe(n);
    });
  }

  /* ---------- Hotspots (arquetipo 17) ---------- */
  function initHotspots() {
    document.querySelectorAll('.hl-hotspots__frame').forEach(function (frame) {
      if (!claim(frame, 'hlHotspots')) return;
      frame.addEventListener('click', function (e) {
        var btn = e.target.closest('.hl-hotspot');
        if (!btn) return;
        var wasOpen = btn.dataset.open === 'true';
        frame.querySelectorAll('.hl-hotspot').forEach(function (h) { h.dataset.open = 'false'; });
        btn.dataset.open = wasOpen ? 'false' : 'true';
      });
      document.addEventListener('click', function (e) {
        if (!frame.contains(e.target)) {
          frame.querySelectorAll('.hl-hotspot').forEach(function (h) { h.dataset.open = 'false'; });
        }
      });
    });
  }

  /* ---------- FAQ (arquetipo 95) ---------- */
  function initFaq() {
    document.querySelectorAll('.hl-faq__list').forEach(function (list) {
      if (!claim(list, 'hlFaq')) return;
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.hl-faq__q');
        if (!btn || !list.contains(btn)) return;
        var item = btn.closest('.hl-faq__item');
        var open = item.dataset.open === 'true';
        item.dataset.open = open ? 'false' : 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- CTA magnetico ---------- */
  function initMagnetic() {
    if (reduced || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.hl-btn--magnetic').forEach(function (btn) {
      if (!claim(btn, 'hlMagnetic')) return;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        btn.style.transform = 'translate(' + (dx * 5).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
      });
      btn.addEventListener('pointerleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Carrusel de reseñas arrastrable (arquetipo 40/71) ---------- */
  function initReviewsSlider() {
    document.querySelectorAll('.hl-reviews__slider').forEach(function (slider) {
      if (!claim(slider, 'hlReviews')) return;
      var track = slider.querySelector('.hl-reviews__track');
      if (!track) return;

      var half = track.scrollWidth / 2;
      var speedSetting = parseFloat(slider.dataset.speed || '46');
      var pxPerMs = half / (speedSetting * 1000);
      var pos = 0;
      var dragging = false;
      var dragStartX = 0;
      var dragStartPos = 0;
      var hovering = false;
      var lastTs = null;

      function apply() { track.style.transform = 'translate3d(' + pos.toFixed(2) + 'px,0,0)'; }

      // Normaliza pos a (-half, 0] sin importar cuanto haya saltado dt
      // (una pestaña en segundo plano puede pausar rAF minutos y volver
      // con un delta enorme de una sola vez: %  evita el salto roto).
      function wrap(p) {
        if (half <= 0) return 0;
        p = p % half;
        if (p > 0) p -= half;
        return p;
      }

      function frame(ts) {
        if (!lastTs) lastTs = ts;
        var dt = Math.min(ts - lastTs, 100); // ignora saltos gigantes tras pausas
        lastTs = ts;
        if (!dragging && !hovering && !reduced) {
          pos = wrap(pos - pxPerMs * dt);
          apply();
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      slider.addEventListener('pointerenter', function () { hovering = true; });
      slider.addEventListener('pointerleave', function () { hovering = false; });

      var hasDragged = false;
      slider.addEventListener('pointerdown', function (e) {
        dragging = true;
        hasDragged = false;
        dragStartX = e.clientX;
        dragStartPos = pos;
        slider.dataset.dragging = 'true';
        slider.setPointerCapture(e.pointerId);
      });
      slider.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (Math.abs(e.clientX - dragStartX) > 6) hasDragged = true;
        pos = wrap(dragStartPos + (e.clientX - dragStartX));
        apply();
      });
      function endDrag() { dragging = false; slider.dataset.dragging = 'false'; }
      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);

      // Tactil: tocar una tarjeta alterna el texto completo (el hover no existe en touch)
      slider.addEventListener('click', function (e) {
        if (hasDragged) return; // era un arrastre, no un tap
        var card = e.target.closest('.hl-reviews__card');
        if (!card) return;
        var full = card.querySelector('.hl-reviews__full');
        if (!full) return;
        var open = full.style.opacity === '1';
        slider.querySelectorAll('.hl-reviews__full').forEach(function (f) { f.style.opacity = ''; });
        full.style.opacity = open ? '' : '1';
      });
    });
  }

  /* ---------- Galeria de la pagina de producto ---------- */
  function initPdpGallery() {
    document.querySelectorAll('.hl-pdp__gallery').forEach(function (gallery) {
      if (!claim(gallery, 'hlGallery')) return;
      var main = gallery.querySelector('.hl-pdp__main img');
      if (!main) return;
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('.hl-pdp__thumb');
        if (!thumb || !gallery.contains(thumb)) return;
        var src = thumb.dataset.full;
        if (src) main.src = src;
        gallery.querySelectorAll('.hl-pdp__thumb').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  function initAll() {
    initReveals();
    initCompare();
    initSteps();
    initStats();
    initHotspots();
    initFaq();
    initMagnetic();
    initReviewsSlider();
    initPdpGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
